// src/theme.js
import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const themeChakra = extendTheme({
  config: {
    initialColorMode: "dark", // default
    useSystemColorMode: false, // don’t let OS override
  },
  styles: {
    global: (props) => ({
      "html, body, #root": {
        bg: mode("white", "gray.900")(props),
        color: mode("gray.800", "whiteAlpha.900")(props),
      },
    }),
  },
  fonts: {
    heading: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    body: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  semanticTokens: {
    colors: {
      "marketplace.bg": { default: "gray.50", _dark: "gray.900" },
      "marketplace.surface": { default: "white", _dark: "gray.800" },
      "marketplace.muted": { default: "gray.50", _dark: "whiteAlpha.100" },
      "marketplace.border": { default: "gray.200", _dark: "gray.700" },
    },
  },
});

export default themeChakra;
